import React from "react";
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import InnerLink from './InnerLink';
import { FormattedDate, FormattedTime } from "react-intl";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Dropzone from "react-dropzone";
import * as agent from "../agent";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

class ReportFileUploader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reports: [],
            uploadProgress: 0,
            filesLoaded: false
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        this.setState({ filesLoaded: false })
        agent.Reports.get()
            .then(res => this.setState({ reports: res, filesLoaded: true }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    onUpload = (files) => {
        agent.Reports.upload(
            "report",
            files,
            e => this.setState({ uploadProgress: e.percent })
        )
        .then(this.fetchData)
        .catch(e => alert(e))
    }

    onDelete = (id) => {
        const { reports } = this.state;
        agent.Reports.delete(id)
            .then(() => this.setState({ reports: reports.filter(r => r._id != id) }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    render() {
        const { reports, uploadProgress, filesLoaded } = this.state;
        let dropzoneRef;
        return (
            <React.Fragment>
                <Dropzone ref={(node) => { dropzoneRef = node; }} className="hidden-dropzone" onDrop={(files) => this.onUpload(files)} />
                <Button size="large"
                        disabled={uploadProgress > 0 && uploadProgress < 100}
                        style={{ height: 49, width: 200 }}
                        color="primary"
                        onClick={() => { dropzoneRef.open() }}
                        variant="contained" >
                    {uploadProgress > 0 && uploadProgress < 100 ? `Загрузка: ${Math.round(uploadProgress)}%` : "Загрузить отчет"}
                </Button>
                {filesLoaded ?
                    reports.length > 0 ?
                        <Table padding="dense" style={{ marginTop: 20 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Дата</TableCell>
                                    <TableCell>Загрузил</TableCell>
                                    <TableCell>Файл</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {reports.map((file, i) => {
                                const { uploadDate, filename, contentType, _id, metadata: {thumb, uploader} = {} } = file;
                                const thumbUrl = agent.src.thumb(thumb);
                                const icon = contentType.startsWith("image") ? thumbUrl : contentType.endsWith("pdf") ? "/images/icons/pdf.png" : contentType.endsWith("sheet") ? "/images/icons/xlsx.png" : "/images/icons/doc.png";
                                return (
                                    <TableRow key={i}>
                                        <TableCell>
                                            <FormattedDate value={uploadDate}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                            <br />
                                            <FormattedTime value={uploadDate}
                                                           hour="numeric"
                                                           minute="numeric"
                                                           second="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            {uploader}
                                        </TableCell>
                                        <TableCell>
                                            <InnerLink href={agent.src.doc(_id)} label={filename} target="_blank" />
                                        </TableCell>
                                        <TableCell>
                                            <img width={50} height={50} src={icon} alt="" />
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={e => {e.preventDefault(); this.onDelete(_id);}} >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table> : <Typography paragraph>Нет загруженных отчетов</Typography> : <React.Fragment><Typography paragraph>Загрузка...</Typography><CircularProgress/ > </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

export default connect(null, null)(ReportFileUploader);



// WEBPACK FOOTER //
// ./src/components/ReportFileUploader.js